import React from 'react';
import cl from './TextArea.module.css';

const TextArea = ({...rest}) => {
    return <textarea className={cl.textArea} {...rest} />
};

export default TextArea;